import React from 'react';

interface UpdateNotificationProps {
    onUpdate: () => void;
}

const UpdateNotification: React.FC<UpdateNotificationProps> = ({ onUpdate }) => {
    return (
        <div 
            role="status"
            aria-live="polite"
            className="fixed bottom-4 right-4 z-50 animate-fade-in-up"
        >
            <div className="bg-white dark:bg-slate-800 rounded-xl shadow-lg p-4 flex items-center justify-between gap-4 border border-indigo-200 dark:border-slate-700 w-full max-w-sm">
                <div className="flex items-center gap-3">
                    <div className="flex-shrink-0">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-500" viewBox="0 0 20 20" fill="currentColor">
                           <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm.707-10.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 001.414 1.414L9 9.414V13a1 1 0 102 0V9.414l.293.293a1 1 0 001.414-1.414l-3-3z" clipRule="evenodd" />
                        </svg>
                    </div>
                    <p className="text-sm font-medium text-gray-800 dark:text-gray-200">
                        應用程式有新版本！
                    </p>
                </div>
                <button
                    onClick={onUpdate}
                    className="px-4 py-2 text-sm font-semibold text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 dark:bg-indigo-700/80 dark:hover:bg-indigo-600 transition-colors active:scale-95 whitespace-nowrap shadow-sm"
                >
                    重新載入
                </button>
            </div>
        </div>
    );
};

export default UpdateNotification;
